/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const BriefcaseIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Briefcase',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M20 18v3.287a.75.75 0 0 1-.75.75L16.75 22a.75.75 0 0 1-.75-.75V18H0v13a1 1 0 0 0 1 1h34a1 1 0 0 0 1-1V18ZM35 10h-9V6a2 2 0 0 0-2-2H12a2 2 0 0 0-2 2v4H1a1 1 0 0 0-1 1v5h16v-1.361a.75.75 0 0 1 .75-.75l2.5.037a.75.75 0 0 1 .75.75V16h16v-5a1 1 0 0 0-1-1ZM13 7h10v3H13Z"
    />
  </svg>`;
};
